var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_17875)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.955 3.91488C22.7075 3.48379 22.3507 3.12563 21.9205 2.87656C21.4903 2.62749 21.0021 2.49634 20.505 2.49634C20.0079 2.49634 19.5196 2.62749 19.0895 2.87656C18.6593 3.12563 18.3025 3.48379 18.055 3.91488L0.912487 33.0824C-0.230013 35.0274 1.13999 37.4999 3.36249 37.4999H37.645C39.8675 37.4999 41.24 35.0249 40.095 33.0824L22.955 3.91488ZM20.5 12.4999C21.8375 12.4999 22.885 13.6549 22.75 14.9874L21.875 23.7549C21.8456 24.0993 21.688 24.4202 21.4334 24.654C21.1788 24.8878 20.8457 25.0175 20.5 25.0175C20.1543 25.0175 19.8212 24.8878 19.5666 24.654C19.312 24.4202 19.1544 24.0993 19.125 23.7549L18.25 14.9874C18.2186 14.673 18.2533 14.3555 18.3521 14.0553C18.4509 13.7551 18.6114 13.479 18.8233 13.2447C19.0353 13.0103 19.294 12.823 19.5828 12.6947C19.8716 12.5664 20.184 12.5001 20.5 12.4999ZM20.505 27.4999C21.168 27.4999 21.8039 27.7633 22.2728 28.2321C22.7416 28.701 23.005 29.3368 23.005 29.9999C23.005 30.6629 22.7416 31.2988 22.2728 31.7676C21.8039 32.2365 21.168 32.4999 20.505 32.4999C19.8419 32.4999 19.2061 32.2365 18.7372 31.7676C18.2684 31.2988 18.005 30.6629 18.005 29.9999C18.005 29.3368 18.2684 28.701 18.7372 28.2321C19.2061 27.7633 19.8419 27.4999 20.505 27.4999Z",
    fill: "#B52A21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_17875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleFill);
export default __webpack_public_path__ + "static/media/exclamation-triangle-fill.0cae52f8ac2d600527370f89bc413730.svg";
export { ForwardRef as ReactComponent };